module.exports = __webpack_public_path__ + "icon-menu.svg?aa6e106b68ab09225040ebc844962911";